var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{staticClass:"product-details-link",attrs:{"link":_vm.teaser.link || {}}},[_c('div',{staticClass:"home-teaser container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }